<template>
	<el-container >
		<el-header class="title" >
			<el-row type="flex" align="middle">
				<el-col :span="12" >
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item >首页</el-breadcrumb-item>
						<el-breadcrumb-item >产品管理</el-breadcrumb-item>
					</el-breadcrumb>
				</el-col>
				<el-col :span="12" align="right">
					<el-button class="el-button--primary vam" size="small" @click="toAddProduct()">
						<i class="el-icon-plus">添加</i>
					</el-button>
					<el-button @click="popUploadExcelConfigView()" icon="el-icon-setting" class="el-button--warning" size="small">Excel格式设置</el-button>
					<el-button @click="popUploadView()" icon="el-icon-upload" type="primary" size="small">上传产品净值Excel</el-button>

					<!--<el-button class="el-button&#45;&#45;primary vam" size="mini" @click="query(1,99)"><i class="el-icon-plus">刷新</i></el-button>-->
				</el-col>
			</el-row>
		</el-header>
		<el-main>
			<el-table size="medium" :data="tableData" header-cell-class-name="table_header" :stripe="true" :height="tableHeight">
				<el-table-column prop="name" label="产品名称">
					<template slot-scope="scope">
						<el-button
							@click.native.prevent="toViewProduct(scope.$index, tableData)"
							type="text"
							size="medium">{{scope.row.name}}
						</el-button>
					</template>
				</el-table-column>
				<!--<el-table-column prop="portion" label="份额" >-->
				<!--</el-table-column>-->
				<!--<el-table-column prop="amount" label="金额">-->
				<!--</el-table-column>-->
				<el-table-column prop="netValue" label="最新净值" :formatter="dataFormatter">
				</el-table-column>
				<el-table-column prop="valueTime" label="最新净值时间" :formatter="dateFormatter">
				</el-table-column>
				<el-table-column prop="status" label="是否前端显示" :formatter="statusFormatter">
				</el-table-column>
				<el-table-column label="操作" width="150">
					<template slot-scope="scope">
						<el-tooltip placement="top" popper-class="my-tooltip" :enterable="false" content="查看历史净值">
							<el-button
								size="mini"
								class="el-button--warning" icon="el-icon-pie-chart" circle @click.native.prevent="toNetValue(scope.$index, tableData)"></el-button>
						</el-tooltip>
						<el-tooltip placement="top" popper-class="my-tooltip" :enterable="false" content="编辑产品信息">
						<el-button
							size="mini"
							class="el-button--primary" icon="el-icon-edit" circle @click.native.prevent="toEditProduct(scope.$index, tableData)"></el-button>
						</el-tooltip>
							<!--<el-button-->
							<!--size="mini"-->
							<!--class="el-button&#45;&#45;danger" icon="el-icon-delete" circle @click="deleteProduct(scope.$index, tableData)"></el-button>-->
					</template>
				</el-table-column>
			</el-table>
			<div style="text-align:right;line-height: 40px;padding-top: 5px;background:#fff;">
				<el-pagination @current-change="currentPageChangeHandler" background layout="total,prev, pager, next" :total="total" :page-size="pageSize">
				</el-pagination>
			</div>
			<el-dialog title="上传产品净值" :visible.sync="showUploadProductNetPanel">
				<upload-product-net-panel ref="uploadProductNetPanel" @uploadsuccess="uploadSuccess"></upload-product-net-panel>
			</el-dialog>
			<el-dialog title="Excel格式设置" :visible.sync="showUploadExcelConfigPanel" width="1280px" height="600px" top="0px" style="top: 50%;left: 50%;margin-top: -300px;margin-left: -640px;width: 1280px;">
				<upload-product-config ref="updateExcelConfigPanel"></upload-product-config>
			</el-dialog>
		</el-main>
	</el-container>
</template>
<script>
	import config from "../../../config/global.js";
	import axios from "axios"
	import UploadProductNetPanel from "./UploadProductNetPanel.vue"
	import Upload from "element-ui/packages/upload/src/upload";
	import UploadProductConfig from "./ProductUploadExcelConfig.vue";

	var deleteProductUrl = config.host+"/backend/product/delete.json";

	export default {
		components: {
			Upload,
			UploadProductNetPanel,
			UploadProductConfig
		},
		props:{

		},
		data() {
			return {
				tableData: [],
				total:0,
				pageSize:50,
				currentPageIndex:1,
				tableHeight:window.innerHeight-170+"px",
				showUploadProductNetPanel:false,
				showUploadExcelConfigPanel:false
			}
		},
		methods:{
			toNetValue(index,data){
				this.$router.push('/index/product/view?id='+data[index].id+"&type=net");
			},
			toEditProduct:function (index,data) {
				this.$router.push('/index/product/view?id='+data[index].id+"&operate=edit");
			},
			toAddProduct(index,data){
				this.$router.push('/index/product/add');
			},
			toViewProduct(index,data){
				this.$router.push('/index/product/view?type=net&id='+data[index].id);
			},
			deleteProduct:function (index,data) {
				this.$confirm('您确定要删除该产品吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(()=>{
					var item = data[index];
					axios({
						method: 'post',
						url:deleteProductUrl+"?id="+item.id,
						data:{}
					}).then((response)=>{
						var defaultResult = this.responseDefaultHandle(response);
						if(defaultResult == false )
							return;
						this.$message({
							message: '产品已成功删除',
							type: 'success'
						});
						this.queryProducts();
					})
						.catch((error)=>{
							console.log(error)
						})
				});
			},
			queryProducts(){
				var start = Math.max(0,(this.currentPageIndex-1)*this.pageSize);
				var size = this.pageSize;
				axios({
					method: 'post',
					url:config.host+'/backend/product/list.json',
					data:{start,size,netValue:true}
				}).then((response)=>{
					var defaultResult = this.responseDefaultHandle(response);
					if(defaultResult == false )
						return;
					var products = response.data.items;
					this.tableData = products;
					this.total = response.data.total;
				})
					.catch((error)=>{
						console.log(error)
					})

//						this.axios.post(config.host+'/backend/product/list.json')
//
//						this.$http.post(config.host+'/backend/product/list.json',{
//							start,
//							size
//						},{
//							emulateJSON:true
//						}).then(function(response){
//							console.log(response)
//						},function(response){
//							console.log(response)
//						});
			},
			currentPageChangeHandler:function (val) {
				this.currentPageIndex = val;
				this.queryProducts();
			},
			popUploadView:function () {
				this.showUploadProductNetPanel = true;
				var ref = this.$refs.uploadProductNetPanel;
				if(ref != null )
					ref.getProductUploadConfig();
			},
			popUploadExcelConfigView:function () {
				this.showUploadExcelConfigPanel = true;
				var ref = this.$refs.updateExcelConfigPanel;
				if(ref != null )
					ref.getProductUploadConfig();
			},
			uploadSuccess:function () {
				this.queryProducts();
			},
			dateFormatter:function (row, column,cellValue,index) {
				if(cellValue.length>10){
					return cellValue.substring(0,10);
				}else{
					return cellValue;
				}
			},
			statusFormatter:function (row, column,cellValue,index) {
				if(cellValue == 1 ){
					return "不显示";
				}else{
					return "显示";
				}
			},
			dataFormatter(row, column, cellValue, index){
				if(typeof cellValue == "number"){
					return cellValue.toFixed(4);
				}else{
					return cellValue;
				}
			},

		},
		mounted:function(){
			this.queryProducts();
		}
	}
</script>
<style scoped>
	.title{
		border-bottom: 1px solid #ddd;
		padding: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/layouts/product/ProductQuery.vue